import type { TOfferStatus } from 'constants/offer';
import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';
import type {
  TLoansApplyOfferData,
  TLoansApplyOfferResponse,
  TLoansReferralApplicationOfferData,
  TLoansReferralApplicationResponse,
  TLoansApplicationV2Response,
  TLoansApplicationV2Data,
} from 'shared/types/TLoansService';

export const applyOfferAPI = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    applyOffer: build.mutation<TLoansApplyOfferResponse, Pick<TLoansApplyOfferData, 'customer' | 'other' | 'client'>>({
      query: (body) => ({
        url: BFF_API_ROUTES.applyOffer,
        method: 'POST',
        body,
      }),
    }),
    sendReferralApplication: build.mutation<
      TLoansReferralApplicationResponse,
      Pick<TLoansReferralApplicationOfferData, 'customer' | 'other' | 'uuid' | 'preApprovalOfferId' | 'client'>
    >({
      query: (body) => ({
        url: BFF_API_ROUTES.sendReferralApplication,
        method: 'POST',
        body,
      }),
    }),
    sendApplicationV2: build.mutation<
      TLoansApplicationV2Response & { offerStatus: TOfferStatus },
      Pick<TLoansApplicationV2Data, 'customer' | 'other' | 'client'>
    >({
      query: (body) => ({
        url: BFF_API_ROUTES.sendApplicationV2,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useApplyOfferMutation, useSendReferralApplicationMutation, useSendApplicationV2Mutation } =
  applyOfferAPI;
